/** 各フェーズ定義 */
export const PHASE = {
  START: 'start',
  EXECUTION: 'execution',
  WRITE_NEW_METER: 'writeNewMeter',
  WRITE_OLD_METER: 'writeOldMeter',
  DISPLAY_WRITING: 'displayWriting',
  DISPLAY_STOP: 'displayStop',
  WRITE_SUCCESS: 'writeSuccess',
  WARNING: 'warning',
  CONNECTION_FAILED: 'connectionFailed',
  DISPLAY_PIN_NUMBER: 'displayPinNumber',
  INPUT_PIN_NUMBER: 'inputPinNumber',
  ERROR_PIN_NUMBER: 'errorPinNumber',
  ODOMETER_FAILED: 'odometerFailed'
};